import React from "react";
import styles from "./NavBar.module.css";
function NavBar() {
  return <div className={styles.container}></div>;
}

export default NavBar;
